module.exports = __webpack_public_path__ + "static/media/m1_sf_16.3bada52b.png";